import "./logoCompo.scss";

import React from "react";
import logo from "../../assets/logo.png";

const LogoCompo = () => {
  return (
    <div className="logoCompo">
      <div className="logoContainor">
        <img src={logo} />
      </div>
    </div>
  );
};

export default LogoCompo;
